import React from 'react'
import { StarIcon } from '../../constants/svgs'

const LeaderboardCard = ({ cardData, index }) => {
    console.log(cardData, "cardData")
    return (
        <div className='leaderboard-card'>
            <div className='px-3'>
                <div className='d-flex justify-content-between align-items-center border-bottom py-4 '>
                    <h6 className='p-0 m-0'>{index + 1}</h6>
                    <h6 className='p-0 m-0'>{cardData?.name}</h6>
                    <div className='d-flex align-items-center'>
                        <div className='star-icon-container'>
                            <StarIcon />
                        </div>
                        <h6 className='p-0 m-0 ms-2'>{cardData?.points} Points</h6>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeaderboardCard